export default __webpack_public_path__ + "static/media/icon-lang-es.480e2260.svg";